import React from 'react'
import { Flex, HStack, Image, Box, Heading, Text, useColorMode, IconButton, Icon } from '@chakra-ui/react'
import { colorKeys, getColor } from '../../config/constants/appColors'
import APP_ICONS from '../../config/constants/icons'
import AvatarNamesStack from '../BasicUI/DataBoxes/AvatarNamesStack'
import DeletePopover from '../BasicUI/DeletePopover'
import { formatDateTimeFromNow } from '../../config/helpers/dateHelper'
import IMAGES from '../../config/constants/images'

const LectureCard = ({ item, onDelete }) => {
  const { colorMode } = useColorMode()

  return (
    <Flex p="1" w="full" justify={"space-between"} _hover={{ bg: getColor(colorKeys.tableRowHoverBackground, colorMode) }} role="group">
      <HStack spacing={3}>
        <Image h="70px" w="80px" src={item?.lecture?.videoMedia?.thumbnailUrl} fallbackSrc={IMAGES.VIMEO_PLACEHOLDER} objectFit={"cover"} />
        <Box>
          <Heading mb="2px" fontSize={"15px"}>{item?.name}</Heading>
          <AvatarNamesStack data={item?.teachers} />
          <Text mt={"5px"} fontSize="12px">Updated {item.updatedBy?.dateTime ? formatDateTimeFromNow(item.updatedBy?.dateTime) : formatDateTimeFromNow(item.createdBy?.dateTime)}</Text>
        </Box>
      </HStack>

      <HStack mr="5" display={"none"} _groupHover={{ display: "flex" }}>
        <IconButton size="sm" icon={<Icon as={APP_ICONS.EDIT} />} />
        <DeletePopover onConfirm={() => onDelete(item.id)} type="lecture">
          <IconButton size="sm" icon={<Icon as={APP_ICONS.BIN} />} />
        </DeletePopover>
      </HStack>
    </Flex>
  )
}

export default LectureCard